import {
  Package,
  Layers,
  MessageSquare,
  ArrowRightLeft,
  Settings,
  Check,
} from 'lucide-react';
import { siteData } from '../../data/mock';
import { useInView } from '../../hooks/useInView';

const iconMap = {
  Package,
  Layers,
  MessageSquare,
  ArrowRightLeft,
  Settings,
};

export const SetupSection = () => {
  const { setup } = siteData;
  const [ref, isInView] = useInView();

  return (
    <section className="py-[90px] lg:py-[110px] bg-white">
      <div
        ref={ref}
        className={`max-w-[1200px] mx-auto px-6 lg:px-8 ${
          isInView ? 'animate-fade-in-up' : 'opacity-0'
        }`}
      >
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          {/* Left: Content */}
          <div>
            <h2 className="font-heading text-[1.85rem] lg:text-[2.5rem] font-bold text-stone-900 leading-[1.15] tracking-[-0.01em]">
              {setup.headline}
            </h2>

            <p className="mt-5 text-[1.05rem] text-stone-500 leading-[1.7]">
              {setup.intro}
            </p>

            <div className="mt-8 space-y-3.5">
              {setup.points.map((point, index) => {
                const Icon = iconMap[point.icon];
                return (
                  <div
                    key={index}
                    className="flex items-center gap-3.5"
                  >
                    <div className="flex-shrink-0 w-8 h-8 rounded-lg bg-[#2d6a5a]/8 flex items-center justify-center">
                      {Icon && <Icon size={15} className="text-[#2d6a5a]" />}
                    </div>
                    <p className="text-stone-600 text-[0.9rem] leading-relaxed">
                      {point.text}
                    </p>
                  </div>
                );
              })}
            </div>

            <p className="mt-8 text-[0.85rem] text-[#2d6a5a] font-medium tracking-wide">
              {setup.trust}
            </p>

            {setup.selfServiceNote && (
              <p className="mt-4 text-[0.84rem] text-stone-400 leading-[1.65]">
                {setup.selfServiceNote}
              </p>
            )}
          </div>

          {/* Right: Highlights */}
          <div className="flex flex-col gap-4 lg:mt-4">
            {setup.highlights.map((highlight, index) => (
              <div
                key={index}
                className="flex items-center gap-3.5 p-5 rounded-2xl bg-[#edf5f2] border border-[#2d6a5a]/8"
              >
                <div className="flex-shrink-0 w-7 h-7 rounded-full bg-[#2d6a5a]/15 flex items-center justify-center">
                  <Check size={13} className="text-[#2d6a5a]" />
                </div>
                <span className="text-stone-800 text-[0.95rem] font-medium">
                  {highlight}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
